module.exports = __webpack_public_path__ + "img/full7-min.fa8ce584.png";